import { CellPropsBase, CellTitle, CellValueArea, FormCell } from '.'
import { ReferencedEntity } from '../../../../../domain/value-object/ReferencedEntity'
import { Autocomplete } from '../../../../components/inputs/Autocomplete'
import {
  renderInputWithIcon,
  renderOptionWithIcon,
} from '../../../../components/inputs/Autocomplete/variants'

type AutocompleteCellProps<Entity extends ReferencedEntity> = {
  value: Entity | undefined
  onChange?: (v: Entity | undefined) => void
  search: (input: string) => Promise<Entity[]>
  displayIcon?: boolean
  renderOption?: (option: Entity) => JSX.Element
  groupBy?: (option: Entity) => string
  sortOptions?: (options: Entity[]) => Entity[]
  defaultExpandedGroups?: string[]
} & CellPropsBase

export const AutocompleteCell = <Entity extends ReferencedEntity>({
  cellWidth,
  label,
  help,
  value,
  onChange,
  search,
  editable = true,
  required = false,
  edited,
  validationErrors,
  displayIcon = false,
  renderOption,
  groupBy,
  sortOptions,
  defaultExpandedGroups,
}: AutocompleteCellProps<Entity>) => {
  return (
    <FormCell cellWidth={cellWidth}>
      <CellTitle title={label} required={required} help={help} />
      <CellValueArea edited={edited} validationErros={validationErrors}>
        <Autocomplete
          value={value}
          onChange={onChange}
          search={search}
          renderInput={displayIcon ? renderInputWithIcon : undefined}
          disabled={!editable}
          renderOption={
            renderOption ?? (displayIcon ? renderOptionWithIcon : undefined)
          }
          groupBy={groupBy}
          sortOptions={sortOptions}
          defaultExpandedGroups={defaultExpandedGroups}
        />
      </CellValueArea>
    </FormCell>
  )
}
